import React from 'react';
import loadable from '@loadable/component';
import _ from 'lodash';

import { capfl } from 'common/utils';
import { ICON_COMPARE } from 'common/constants/IconConstants';

const ButtonOutline = loadable(
  () => import('common/components/styleguide/ButtonOutline'),
  {
    ssr: true
  }
);
const Icon = loadable(() => import('common/components/styleguide/Icon'), {
  ssr: true
});
const TextIcon = loadable(
  () => import('common/components/styleguide/TextIcon'),
  {
    ssr: true
  }
);

const AddToCompareButtonVariant1 = ({
  t,
  productId,
  title = 'add to compare',
  iconClassName = ICON_COMPARE,
  dispatchAddProductToCompare = null,
  customStyle,
  linkType = 'primary',
  ...rest
}) => {
  return (
    <ButtonOutline
      href="#"
      component={'a'}
      buttonType={'info'}
      buttonSize={'small'}
      margin={'2px'}
      enableBackground={true}
      onClick={e => {
        e.preventDefault();
        dispatchAddProductToCompare(productId);
      }}
      customStyle={_.get(customStyle, 'link', undefined)}
      linkType={linkType}
      title={capfl(t('add to compare'))}
      {...rest}
    >
      {title ? (
        <TextIcon iconClassName={iconClassName}>{capfl(t(title))}</TextIcon>
      ) : (
        <Icon className={iconClassName} />
      )}
    </ButtonOutline>
  );
};

export default React.memo(AddToCompareButtonVariant1);
